import { render } from "./Carousel.vue?vue&type=template&id=f340958c&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=f340958c&lang=scss&scoped=true&var=%7Bwidth%7D"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f340958c"]])

export default __exports__